export default __webpack_public_path__ + "static/media/components.33a00ab0.webp";